export const NOTIFICATION_TYPE = {
  TRIKE_GEOFENCE: 1,
  ASSIGN_BATTERIES: 2,
  DRIVER_LICENSE_EXPIRE: 3,
  ACCEPT_BATTERY_REQUEST: 4,
  HUB_ACCEPTED_REQUEST: 5,
  HUB_REJECTED_REQUEST: 6,
  BATTERY_CHECK_IN_REQUEST: 7,
  BATTERY_CHECK_OUT_REQUEST: 8,
  ASSIGN_BATTERIES_FOR_SESSION: 9,
  NEW_PURCHASE_REQUEST: 10,
  NEW_SESSION_REQUEST: 11,
  NEW_TRANSPORT_REQUEST: 12,
  NEW_FARMER_ADDED: 13,
  HUB_TRIP_BATTERY_SHORTAGE: 14,
  HUB_SESSION_BATTERY_SHORTAGE: 15,
  RENTAL_REQUEST: 16,
  BATT_RENTAL_REQUEST: 17,
  MORE_BATT_DRIVER_REQUEST: 18,
  NO_FEEDBACK: 19,
  TRIP_CHECKLIST_FAILED: 20,
  SESSION_CHECKLIST_FAILED: 21,
  RENTAL_CHECKLIST_FAILED: 22,
  TIMEOFF: 23,
  RENTAL_PURCHASE: 24,
  ENERGY_PURCHASE: 25,
  RENTAL_RECEIVED: 26,
  BATTERY_SOS_REQUEST: 27,
  TRIKE_REPAIR_SOS: 28,
  NEW_FEED_REQUEST: 29,
  TRIKE_REPLACEMENT_REQUESTED: 30,
};

